import { motion } from "framer-motion";
import { useState } from "react";
import { Link } from "react-router-dom";

const links = [
    { label: "Telegram", to: "/telegram" },
    { label: "Cara Registrasi", to: "/panduan-registrasi" },
];

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <motion.nav
            className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-gradient-to-b from-[#0c0015] via-[#07000c] to-transparent backdrop-blur-xl shadow-[0_20px_50px_rgba(0,0,0,0.65)]"
            initial={{ y: -80, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
        >
            <div className="mx-auto max-w-6xl px-6">
                <div className="flex h-20 items-center justify-between">
                    <div className="flex items-center gap-12">
                        <a href="/" className="flex items-center gap-3">
                            <img src="/logo.png" alt="ArfaFX" className="h-12 w-auto object-contain" />
                        </a>

                        <div className="hidden lg:flex items-center gap-8 text-sm font-medium">
                            {links.map((item) => (
                                <Link
                                    key={item.label}
                                    to={item.to}
                                    className="text-white/70 hover:text-white transition-colors"
                                >
                                    {item.label}
                                </Link>
                            ))}
                        </div>
                    </div>

                    <div className="hidden lg:flex items-center">
                        <a
                            href="https://t.me/joinpremiumarfafx"
                            className="inline-flex rounded-full bg-gradient-to-br from-[#ff00bf] to-[#ff7fec] px-6 py-2 text-sm font-semibold text-white hover:scale-[1.1] transition-transform"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Join
                        </a>
                    </div>

                    <button
                        className="lg:hidden text-white focus:outline-none"
                        onClick={() => setIsOpen(!isOpen)}
                    >
                        <span className="sr-only">Toggle Menu</span>
                        <div className="space-y-1.5">
                            <span className="block h-0.5 w-6 bg-white"></span>
                            <span className="block h-0.5 w-6 bg-white"></span>
                            <span className="block h-0.5 w-6 bg-white"></span>
                        </div>
                    </button>
                </div>

                {isOpen && (
                    <div className="lg:hidden mt-4 space-y-4 pb-4">
                        {links.map((item) => (
                            <Link
                                key={item.label}
                                to={item.to}
                                className="block text-white/80 font-medium hover:text-white"
                                onClick={() => setIsOpen(false)}
                            >
                                {item.label}
                            </Link>
                        ))}
                        <a
                            href="https://t.me/joinpremiumarfafx"
                            className="inline-flex rounded-full bg-gradient-to-br from-[#ff00bf] to-[#ff7fec] px-6 py-2 text-sm font-semibold text-white hover:scale-[1.1] transition-transform"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Join
                        </a>
                    </div>
                )}
            </div>
        </motion.nav>
    );
};

export default Navbar;

